import { combineReducers } from "redux";
import show, { PostArticlesShowState } from "./reducers/showReducer";

export type PostArticlesState = {
  show: PostArticlesShowState;
};

export default combineReducers({
  show,
});



// WEBPACK FOOTER //
// ./frontend/src/post_articles/reducer.ts